const changelog = {
	title: "Endringslogg",
};
export default changelog;